module.exports = __webpack_public_path__ + "static/media/ic_esign_otp_finity.0ede0268.svg";